export default {
    CANCERO: 1,
    DIABETES: 2,
    ETILISMO: 3,
    HIPERTENSAO: 4,
    OBESIDADE: 5,
    PERFIL_SANGUINEO_ALTERADO: 6,
    RADIOTERAPIA: 7,
    TABAGISMO: 8,
    USO_DE_MEDICAMENTOS_ANTINEOPLASICOS_OU_IMUNOSSUPRESSORES: 9,
    OUTRO: 10,
    GESTANTE: 11,
}